import { ReactNode } from "react";
import { SubNav, SubNavTab } from "@/components/layout/SubNav";

interface MonitoringLayoutProps {
  children: ReactNode;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const monitoringTabs: SubNavTab[] = [
  { label: "Activity Log", path: "/monitoring/activity-log" },
  { label: "API Rate Monitor", path: "/monitoring/rate" },
  { label: "Queue Management", path: "/monitoring/queues" },
  { label: "Cache Management", path: "/monitoring/cache" },
  { label: "SQL Activity", path: "/monitoring/sql-activity" },
  { label: "ADF Monitor", path: "/monitoring/adf" },
  { label: "ADF Health", path: "/monitoring/adf-health" },
];

export const MonitoringLayout = ({ children, onRefresh, isRefreshing }: MonitoringLayoutProps) => {
  return (
    <div className="flex flex-col h-full">
      <SubNav tabs={monitoringTabs} onRefresh={onRefresh} isRefreshing={isRefreshing} />
      <div className="flex-1 min-h-0">
        {children}
      </div>
    </div>
  );
};
